if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        this.values = {};
        this.querySelectorAll('[data-unit]').forEach((el) => {
          this.values[el.dataset.unit] = el;
        });
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      getEndTime() {
        if (this.dataset.mode === 'daily') {
          const midnight = new Date();
          midnight.setHours(24, 0, 0, 0);
          return midnight.getTime();
        }
        const end = new Date(this.dataset.end);
        return isNaN(end.getTime()) ? null : end.getTime();
      }

      tick() {
        // Accessibility toolbar "stop animations": keep the last shown time instead of ticking.
        if (this.rendered && document.documentElement.classList.contains('a11y-motion')) return;
        this.rendered = true;
        const end = this.getEndTime();
        const remaining = end === null ? 0 : Math.max(0, end - Date.now());

        if (remaining === 0) {
          clearInterval(this.interval);
          if (this.dataset.expiredBehavior === 'hide') {
            const section = this.closest('.shopify-section');
            if (section && !window.Shopify?.designMode) section.hidden = true;
          }
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const parts = {
          days: Math.floor(totalSeconds / 86400),
          // Without a days unit the hours keep counting past 24 (e.g. 47:59:59).
          hours: Math.floor((this.values.days ? totalSeconds % 86400 : totalSeconds) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60,
        };

        Object.entries(parts).forEach(([unit, value]) => {
          if (this.values[unit]) this.values[unit].textContent = String(value).padStart(2, '0');
        });
      }
    }
  );
}
